import { IEventStatus } from "../types/IEventStatus";
import { IEventType } from "../types/IEventType";
import { IServiceEvent } from "../types/IServiceEvent";
import { Api } from "./api";

export const PostEventStatus = async (
    event: IServiceEvent,
    type: IEventType,
    message: string,
    status: IEventStatus
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
    const api = await Api();
    const data = {
        serviceId: event.id,
        eventId: event.eventId,
        subServiceId: event.serviceKey,
        eventData: event.data,
        message: message,
        type: type,
        serviceArn: event.serviceArn,
        status: status
    };
    const apiResponse = await api
        .post(`dashboard-ui/service/resolve`, data)
        .then((result) => {
            return result;
        });

    return apiResponse;
};
